import React, { useState, useCallback } from 'react';
import { Spin, Alert } from 'antd';
import { useH303Query } from './hooks/useH303Query';
import QueryParams from './components/QueryParams';
import ResultTable from './components/ResultTable';
import type { QueryRequest } from '../../services/h303Api';
import './H303Form.css';

const H303Form: React.FC = () => {
  const { loading, result, queried, noData, runQuery } = useH303Query();

  const [supplierFrom, setSupplierFrom] = useState('');
  const [supplierTo, setSupplierTo] = useState('');
  const [yearMonFrom, setYearMonFrom] = useState('');
  const [yearMonTo, setYearMonTo] = useState('');
  const [deptFrom, setDeptFrom] = useState('');
  const [deptTo, setDeptTo] = useState('');
  const [buyerFrom, setBuyerFrom] = useState('');
  const [buyerTo, setBuyerTo] = useState('');
  const [check1, setCheck1] = useState(false); // 部門廠商別
  const [check2, setCheck2] = useState(false); // 廠商部門別

  // Determine report type based on checkbox state
  // If both checked, query deptSupplier first (the primary view)
  const getReportType = useCallback((): string => {
    if (check2 && !check1) return 'supplierDept';
    return 'deptSupplier';
  }, [check1, check2]);

  const handleQuery = useCallback(() => {
    if (!check1 && !check2) return;

    const req: QueryRequest = {
      supplierFrom: supplierFrom.trim(),
      supplierTo: supplierTo.trim(),
      yearMonFrom: yearMonFrom.trim(),
      yearMonTo: yearMonTo.trim(),
      deptFrom: deptFrom.trim(),
      deptTo: deptTo.trim(),
      buyerFrom: buyerFrom.trim(),
      buyerTo: buyerTo.trim(),
      reportType: getReportType(),
    };
    runQuery(req);
  }, [supplierFrom, supplierTo, yearMonFrom, yearMonTo, deptFrom, deptTo, buyerFrom, buyerTo, check1, check2, getReportType, runQuery]);

  return (
    <Spin spinning={loading}>
      <div className="h303-container max-w-7xl mx-auto p-4">
        <h2 className="text-xl font-bold mb-4">
          應付帳款沖帳明細 (H3031)
        </h2>

        <QueryParams
          supplierFrom={supplierFrom}
          supplierTo={supplierTo}
          yearMonFrom={yearMonFrom}
          yearMonTo={yearMonTo}
          deptFrom={deptFrom}
          deptTo={deptTo}
          buyerFrom={buyerFrom}
          buyerTo={buyerTo}
          check1={check1}
          check2={check2}
          loading={loading}
          onSupplierFromChange={setSupplierFrom}
          onSupplierToChange={setSupplierTo}
          onYearMonFromChange={setYearMonFrom}
          onYearMonToChange={setYearMonTo}
          onDeptFromChange={setDeptFrom}
          onDeptToChange={setDeptTo}
          onBuyerFromChange={setBuyerFrom}
          onBuyerToChange={setBuyerTo}
          onCheck1Change={setCheck1}
          onCheck2Change={setCheck2}
          onQuery={handleQuery}
        />

        {queried && !noData && result && (
          <ResultTable result={result} reportType={getReportType()} />
        )}

        {queried && noData && (
          <Alert
            message="查無資料"
            description="查無符合條件的應付帳款沖帳資料！請確認篩選條件是否正確。"
            type="info"
            showIcon
          />
        )}
      </div>
    </Spin>
  );
};

export default H303Form;
